"use client";
import React from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Stack } from "@/components/ui/layout";
import { Text } from "@/components/ui/typography";
import { X } from "lucide-react";
import { cn } from "@/lib/utils";

const ModalHeader = ({ title, description, iconSrc }) => {
  return (
    <DialogHeader>
      <div className="flex items-center gap-3">
        {iconSrc && <img src={iconSrc} alt="Confirmation icon" className="w-12 h-12" />}
        <div>
          <DialogTitle>{title}</DialogTitle>
          <DialogDescription>{description}</DialogDescription>
        </div>
      </div>
    </DialogHeader>
  );
};

function Modal({ isOpen = true, onClose, onConfirm }) {
  if (!isOpen) return null;

  const handleCancel = () => {
    if (onClose) onClose();
  };

  const handleConfirm = () => {
    if (onConfirm) onConfirm();
    if (onClose) onClose();
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-md">
        <ModalHeader
          title="Confirm to Save Video?"
          description="Would you like to save this video for future access?"
          iconSrc="https://cdn.builder.io/api/v1/image/assets/TEMP/8cfc0a2f8155aae9900ca77731e7655ba8415d2d4088743b3769daccde5717ba?placeholderIfAbsent=true&apiKey=adec8590503446dea9751332b3a30a3d"
        />
        <DialogFooter>
          <Button variant="outline" onClick={handleCancel}>
            Cancel
          </Button>
          <Button onClick={handleConfirm}>
            Confirm
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}

export default Modal;
